// src/MidpointUtils.tsx


interface LatLng {
  lat: number;
  lng: number;
}
  
	export const interpolate = (start: [number, number], end: [number, number], fraction: number): LatLng => {
	  const lat = start[0] + (end[0] - start[0]) * fraction;
	  const lng = start[1] + (end[1] - start[1]) * fraction;
	  return { lat, lng };
	};
	
	export const calculateGoogleRouteMidpoint = (route: any): LatLng => {
	  
	  console.log('calculateRouteMidpoint route.sections'+route.sections);
	  if (!route || !route.sections) {
		throw new Error("Invalid route data");
	  }

	  const totalDistance = route.sections.reduce((sum: number, section: any) => sum + section.summary.length, 0);
	  let traveledDistance = 0;
	  let midpoint: LatLng = { lat: 0, lng: 0 };

	  for (const section of route.sections) {
		const sectionDistance = section.summary.length;
		console.log('calculateRouteMidpoint section length'+sectionDistance);

		if (traveledDistance + sectionDistance >= totalDistance / 2) {
		  const remainingDistance = totalDistance / 2 - traveledDistance;
		  const fraction = remainingDistance / sectionDistance;

		  // Decode the polyline to get a more accurate midpoint
		  const polyline = decodePolyline(section.polyline);
		  let polylineDistance = 0;

		  for (let i = 0; i < polyline.length - 1; i++) {
			const segmentStart : any = polyline[i];
			const segmentEnd : any = polyline[i + 1];
			const segmentDistance = computeDistanceBetween(segmentStart as [number, number], segmentEnd as [number, number]);

			if (polylineDistance + segmentDistance >= remainingDistance) {
			  const segmentFraction = (remainingDistance - polylineDistance) / segmentDistance;
			  midpoint = interpolate(segmentStart, segmentEnd, segmentFraction);
			  break;
			}
			polylineDistance += segmentDistance;
		  }
		  break;
		}
		traveledDistance += sectionDistance;
	  }
	  return midpoint;
	};

	// Helper function to decode polyline
	export const decodePolyline = (encoded : any) => {
	  let points = [];
	  let index = 0, len = encoded.length;
	  let lat = 0, lng = 0;

	  while (index < len) {
		let b, shift = 0, result = 0;
		do {
		  b = encoded.charAt(index++).charCodeAt(0) - 63;
		  result |= (b & 0x1f) << shift;
		  shift += 5;
		} while (b >= 0x20);
		let dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
		lat += dlat;

		shift = 0;
		result = 0;
		do {
		  b = encoded.charAt(index++).charCodeAt(0) - 63;
		  result |= (b & 0x1f) << shift;
		  shift += 5;
		} while (b >= 0x20);
		let dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
		lng += dlng;

		points.push({ lat: lat / 1e5, lng: lng / 1e5 });
	  }

	  return points;
	};

	// Helper function to compute distance between two points
	export const computeDistanceBetween = (point1: [number, number], point2: [number, number]) => {
	  const R = 6371000; // Radius of the Earth in meters
	  const dLat = (point2[0] - point1[0]) * Math.PI / 180;
	  const dLng = (point2[1] - point1[1]) * Math.PI / 180;
	  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(point1[0] * Math.PI / 180) * Math.cos(point2[0] * Math.PI / 180) *
				Math.sin(dLng / 2) * Math.sin(dLng / 2);
	  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  return R * c;
	};
  
  export const calculateDistance = (location1: LatLng, location2: LatLng): number => {
    const R = 3958.8; // Radius of the Earth in miles
    const rlat1 = location1.lat * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = location2.lat * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (location2.lng - location1.lng) * (Math.PI / 180); // Radian difference (longitudes)

    const d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) +
      Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
    return d;
  };
  
	export const getLatLng = (location: any) => {
	  return {
		lat: parseFloat(location.lat),
		lng: parseFloat(location.lng)
	  };
	};  
	
	export const calculateHaversineDistance = (lat1: number, lon1: number, lat2: number, lon2: number, unit: 'M' | 'K' | 'N'): number => {
	  const R = unit === 'M' ? 3958.8 : (unit === 'K' ? 6371 : 3440); // Radius of Earth in miles, kilometers, or nautical miles
	  const dLat = toRadians(lat2 - lat1);
	  const dLon = toRadians(lon2 - lon1);
	  const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  return R * c;
	};

	const toRadians = (degrees: number): number => {
	  return degrees * Math.PI / 180;
	};
  